import { cn } from "@/lib/utils";

/**
 * Bloco de esqueleto genérico (padrão "tudo que carrega mostra carregamento",
 * decreto 03/set/2026). Server Component puro — sem `Date.now()`/`window`,
 * sem estado — usável direto em qualquer `loading.tsx` (fallback automático
 * do Suspense de rota do Next) ou dentro de um `<Suspense fallback>` pontual.
 *
 * - `animate-pulse` é a única animação; `motion-reduce:animate-none` respeita
 *   `prefers-reduced-motion` (a Key não tem regra global equivalente em
 *   `globals.css`, então isto fica explícito aqui — autocontido).
 * - `aria-hidden`: puramente decorativo. Quem monta a tela
 *   (components/loading/page-skeletons.tsx) envolve o conjunto num
 *   `role="status"` com um `<span className="sr-only">Carregando…</span>`
 *   — um anúncio só pro leitor de tela, não um por bloco.
 * - Cores em `bg-slate-*` direto (tokens do DESIGN.md da Key — este repo não
 *   declara `bg-muted`/`border-border` semânticos em `globals.css`).
 */
export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse motion-reduce:animate-none rounded-md bg-slate-800", className)}
      {...props}
    />
  );
}
